export const WELLBEING_SLIDER = "WellbeingSlider";
export const WELLBEING_TITLE = "WellbeingTitle";
export const WELLBEING_DIVIDER = "WellbeingDivider";
export const WELLBEING_CARD_ID = "WellbeingCardId";
